@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.iconWithStatus {
  display: flex;
  align-items: center;
  position: relative;
}

[data-ff-post-approvals='on'] {
  .alertOverlay {
    width: 18px;
    height: 18px;
    top: -10px;
    right: -18px;
  }
}

@include for-phone-only {
  .alertOverlay {
    top: unset !important;
    bottom: -4px !important;
    right: -6px !important;

    width: 12px !important;
    height: 12px !important;

    svg {
      width: 8px !important;
      height: 8px !important;
    }
  }
}

.alertOverlay {
  position: absolute;
  bottom: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.errorOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-90);
  }
}

.reauthOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-90);
    padding-bottom: 1px;
  }
}

.warningOverlay {
  background: var(--yellow-50);
}

.successOverlay {
  background: var(--green-50);
}
